import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import { TYPES, FORMATS } from '@pixi/constants';
var GLTexture = /*#__PURE__*/_createClass(function GLTexture(texture) {
  _classCallCheck(this, GLTexture);
  this.texture = texture;
  this.width = -1;
  this.height = -1;
  this.dirtyId = -1;
  this.dirtyStyleId = -1;
  this.mipmap = false;
  this.wrapMode = 33071;
  this.type = TYPES.UNSIGNED_BYTE;
  this.internalFormat = FORMATS.RGBA;
  this.samplerType = 0;
});
export { GLTexture };